import { CodeDTO } from '@/models/CodeDTO';
import ApiService from './api.service';

export default class CodeService {
    /**
     * Get reasons for long appointment
     *
     * @returns {CodeDTO[]} a list of LocalityDTO object
     */
    public static async fetchCodes(className: string): Promise<CodeDTO[]> {
        return await ApiService.get(`${process.env.VUE_APP_PUBLIC_ROOT_API}/Codes/codes/${className}`)
        .then((response: any) => {
            return response.data;
        });
    }
}
